import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowUpRight } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext/ThemeContext';

const NAV_SECTIONS = [
  {
    heading: 'Platform',
    links: [
      { to: '/worker',   label: 'Browse Jobs' },
      { to: '/provider', label: 'Post Work' },
      { to: '/about',    label: 'About Us' },
      { to: '/',         label: 'Register' },
    ],
  },
  {
    heading: 'Support',
    links: [
      { to: '/contact', label: 'Help Center' },
      { to: '/contact', label: 'Privacy Policy' },
      { to: '/contact', label: 'Terms of Service' },
      { to: '/contact', label: 'FAQs' },
    ],
  },
];

const CONTACT_INFO = [
  { icon: Mail,   href: 'mailto:khushichauhan@gmail.com', label: 'khushichauhan@gmail.com' },
  { icon: Phone,  href: 'tel:+918860013597',              label: '+91 88600 13597' },
  { icon: MapPin, href: '#',                              label: 'Gurugram, Haryana 122001' },
];

const Footer = () => {
  const { isDark } = useTheme();

  const bg = isDark ? '#000000' : '#ffffff';
  const textPrimary = isDark ? '#ffffff' : '#000000';
  const textMuted = isDark ? '#a1a1aa' : '#475569';
  const border = isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';

  return (
    <footer className="relative z-10 border-t" style={{ background: bg, borderColor: border }}>
      <div className="section-container-wide">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 py-16">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2.5 mb-5">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: textPrimary, color: bg }}>
                <span className="font-bold text-sm">M</span>
              </div>
              <span className="text-base font-bold tracking-tight" style={{ color: textPrimary }}>MattersUrSkills</span>
            </Link>
            <p className="text-sm leading-relaxed max-w-xs mb-6" style={{ color: textMuted }}>
              Empowering India's skilled workforce with verified opportunities, safe payments, and transparent reviews — connecting workers and businesses since 2024.
            </p>
            <div className="space-y-3">
              {CONTACT_INFO.map(({ icon: Icon, href, label }) => (
                <a key={label} href={href} className="flex items-center gap-2.5 text-sm transition-colors duration-200 group" style={{ color: textMuted }}>
                  <Icon className="w-4 h-4 flex-shrink-0" />
                  <span className="group-hover:underline" style={{ color: textMuted }}>{label}</span>
                </a>
              ))}
            </div>
          </div>
          {NAV_SECTIONS.map(({ heading, links }) => (
            <div key={heading}>
              <p className="text-xs font-semibold uppercase tracking-widest mb-4" style={{ color: textMuted }}>{heading}</p>
              <ul className="space-y-2.5">
                {links.map(({ to, label }) => (
                  <li key={label}>
                    <Link to={to} className="inline-flex items-center gap-1 text-sm transition-colors duration-200 group" style={{ color: textMuted }}>
                      <span className="group-hover:underline">{label}</span>
                      <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t py-6 flex flex-col sm:flex-row items-center justify-between gap-3" style={{ borderColor: border }}>
          <div className="flex-1"></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
